import {useAsyncState} from 'common/hooks/useAsyncState';
import ApiService from 'api/ApiService';
import React from 'react';
import {useHandleApiError} from './useHandleApiError';
import {FormOnSubmitHelpers} from 'components/hook-form/Formik';

type CallbackOptions = {
   onSuccess?: () => void;
   onFailure?: (error: any, message: string) => void;
};

type ApiOptions = CallbackOptions & {
   // persistState?: boolean;
   hideToast?: boolean;
};

type RequestOptions = CallbackOptions & {
   body?: BodyInit;
   urlParams?: string;
   searchParams?: Record<string, any>;
   helpers?: FormOnSubmitHelpers<any>;
};

export function useDeleteApi(url: string, options?: ApiOptions) {
   const {loading, error, setLoading, setError} = useAsyncState();

   const handleError = useHandleApiError({
      url,
      setError,
      setLoading,
      hideToast: options?.hideToast,
   });

   const request = React.useCallback(
      (requestOptions?: RequestOptions) => {
         setLoading(true);
         let _url = url;
         if (requestOptions?.urlParams) {
            _url = url + requestOptions.urlParams;
         }
         if (requestOptions?.searchParams) {
            _url = `${_url}?${new URLSearchParams(requestOptions?.searchParams)}`;
         }
         return ApiService.deleteSecureJson(_url, requestOptions?.body)
            .then((response) => {
               setLoading(false);
               options?.onSuccess?.();
               requestOptions?.onSuccess?.();
               return response;
            })
            .catch(handleError(options?.onFailure || requestOptions?.onFailure));
      },
      [handleError, options, setLoading, url]
   );
   return {request, loading, error};
}
